import React, { Component, useDebugValue, useEffect } from "react";
import auth from "../services/authService";
import { useSelector } from "react-redux";
import { getHostDetails } from "../app/store/auth";
import { use } from "react";
const Logout = () => {
  // async componentDidMount() {
  //   // const user = auth.getCurrentUser();
  //   // if (user === null) window.location = "/AdminLogin";

  //   auth.logout();
  //   window.location = "/Login";
  //   // if (user.type !== "admin" && user.type !== "workflow")
  //   //   window.location = "/AdminLogin";
  //   // if (user.type === "admin" && user.type === "workflow")
  //   //   window.location = "/AdminLogin";
  //   // if (user.type === "workflow") window.location = "/PartnerLogin";

  //   // if (user.type === undefined) window.location = "/AdminLogin";
  // }

  // render() {
  //   return null;
  // }

  const hostDetailsSelector = useSelector(getHostDetails)

  useEffect(() => {
    console.log(hostDetailsSelector);
    //auth.logout();
    //window.location = "/login"
  }, []);

  useEffect(() => {
    console.log(hostDetailsSelector)
  }, [hostDetailsSelector])

  return <></>

}

export default Logout;
